module.exports = __webpack_public_path__ + "static/media/customer-coca-cola.b7c09840.png";